import { multicastChannel } from "redux-saga";
import actions from "./actions";

const initState = {
    addChatrBulkRechargeLoading: false,
    addChatrBulkRechargeError: null,
    addChatrBulkRechargeMessage: null,

    chatrRechargeLoading: false,
    chatrRechargeError: null,
    chatrRechargeResult: [],

    bulkChatrRechargeResultByBatchID: [],
    bulkChatrRechargeResultByBatchIDLoading: false,
    bulkChatrRechargeResultByBatchIDError: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.RESET_CHATR_MESSAGES:
            return {
                ...state,
                addChatrBulkRechargeMessage: null,
                addChatrBulkRechargeError: null,
            };
        case actions.ADD_CHATR_BULK_RECHARGE:
            return {
                ...state,
                addChatrBulkRechargeLoading: true,
                addChatrBulkRechargeError: null,
                addChatrBulkRechargeMessage: null,
            };
        case actions.ADD_CHATR_BULK_RECHARGE_SUCCESS:
            return {
                ...state,
                addChatrBulkRechargeLoading: false,
                addChatrBulkRechargeError: null,
                addChatrBulkRechargeMessage: action.payload.message,
            };
        case actions.ADD_CHATR_BULK_RECHARGE_FAILED:
            return {
                ...state,
                addChatrBulkRechargeLoading: false,
                addChatrBulkRechargeError: action.payload.error,
                addChatrBulkRechargeMessage: null,
            };
        case actions.GET_CHATR_RECHARGE_REQUEST_LIST:
            return {
                ...state,
                chatrRechargeLoading: true,
                chatrRechargeResult: [],
                chatrRechargeError: null,
            };
        case actions.GET_CHATR_RECHARGE_REQUEST_LIST_SUCCESSFUL:
            return {
                ...state,
                chatrRechargeLoading: false,
                chatrRechargeResult: action.payload.data,
                chatrRechargeError: null,
            };
        case actions.GET_CHATR_RECHARGE_REQUEST_LIST_FAILED:
            return {
                ...state,
                chatrRechargeError: action.payload.activationError,
                chatrRechargeLoading: false,
                chatrRechargeResult: []
            };
        case actions.RESET_CHATR_VALIDATE_MESSAGE:
            return {
                ...state,
                addChatrBulkRechargeMessage: null,
                addChatrBulkRechargeError: null,
            };

        case actions.GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST:
            return {
                ...state,
                bulkChatrRechargeResultByBatchIDLoading: true,
                bulkChatrRechargeResultByBatchID: null,
                bulkChatrRechargeResultByBatchIDError: action.error,
            };
        case actions.GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST_FAILED:
            return {
                ...state,
                bulkChatrRechargeResultByBatchIDLoading: false,
                bulkChatrRechargeResultByBatchID: action.payload.result,
                bulkChatrRechargeResultByBatchIDError: null,
            };
        case actions.GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST_FAILED:
            return {
                ...state,
                bulkChatrRechargeResultByBatchIDLoading: false,
                bulkChatrRechargeResultByBatchID: null,
                bulkChatrRechargeResultByBatchIDError: action.error,
            };

        default:
            return state;
    }
}
